import { PostHogProvider } from "posthog-js/react";
import { Env } from "@chesspresso/common";
import type { PropsWithChildren } from "react";

const env = Env.client();

export const PosthogProvider = ({ children }: PropsWithChildren) => {
    if (env.DEV) {
        return children;
    }

    return (
        <PostHogProvider
            apiKey={env.VITE_PUBLIC_POSTHOG_KEY}
            options={{
                api_host: env.VITE_PUBLIC_POSTHOG_HOST,
                defaults: "2025-05-24",
                capture_exceptions: true,
                debug: env.DEV,
            }}
        >
            {children}
        </PostHogProvider>
    );
};
